import { Component, OnInit } from '@angular/core';

import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ICustomTaskAction } from '../../interfaces/custom-task-action';
import { ICustomTaskActionService } from '../../services';

@Component({
  selector: 'custom-task-action',
  templateUrl: './manage-task-custom-action.component.html',
  styles: [
    `
      .checkPos {
        font-size: 14px;
        float: right;
        margin: 15px 5px 0 0;
      }
    `,
  ],
  providers: [ICustomTaskActionService],
})
export class CustomTaskActionsComponent implements OnInit {
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public customtaskaction: ICustomTaskAction;
  public newcustomtaskaction: boolean = false;
  public newCustomTaskActionForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public order: UntypedFormControl;
  public completed: UntypedFormControl;
  actions: ICustomTaskAction[];

  constructor(private iCustomTaskActionService: ICustomTaskActionService) {}

  ngOnInit() {
    this.actions = [
      {
        id: 1,
        name: 'Change the tyres',
        order: 0,
        completed: false,
        taskid: 0,
        isPickUp: true,
        completedDate: null,
      },
      {
        id: 2,
        name: 'Fill the tank',
        order: 1,
        completed: true,
        taskid: 0,
        isPickUp: true,
        completedDate: null,
      },
      {
        id: 3,
        name: 'Drink a soda',
        order: 2,
        completed: true,
        taskid: 0,
        isPickUp: true,
        completedDate: null,
      },
      {
        id: 4,
        name: 'Clean the seats',
        order: 3,
        completed: false,
        taskid: 0,
        isPickUp: true,
        completedDate: null,
      },
    ];

    // set formGroup instance
    this.name = new UntypedFormControl('', Validators.required);
    this.order = new UntypedFormControl(this.actions.length, Validators.required);
    this.completed = new UntypedFormControl(true, Validators.required);

    this.newCustomTaskActionForm = new UntypedFormGroup({
      name: this.name,
      order: this.order,
      completed: this.completed,
    });
  }

  showDialogToAdd() {
    this.newcustomtaskaction = true;
    this.customtaskaction = {
      name: '',
      id: 0,
      order: this.actions.length,
      completed: true,
      taskid: 0,
      isPickUp: true,
      completedDate: null,
    };
    this.displayDialog = true;
  }

  save(formValues) {
    this.customtaskaction.id = 0;
    this.customtaskaction.name = formValues.name;
    this.customtaskaction.order = this.actions.length;
    this.customtaskaction.completed = formValues.completed;
    this.customtaskaction.taskid = 0;

    this.actions.push(this.customtaskaction);
    this.displayDialog = false;
    console.log(this.actions);
  }
  selectionChanged(e) {
    console.log(e.value);
  }

  reOrdered(actionslist: ICustomTaskAction[]) {
    for (let i = 0; i < actionslist.length; i++) {
      actionslist[i].order = i;
    }
    this.iCustomTaskActionService.saveactionslist(actionslist);
  }

  delete() {
    this.displayDialog = false;
  }
}
